import React from "react";
import Hero from "../../components/REMA/Hero";
import RemaConferenceTicker from "../../components/REMA/RemaConferenceTicker";
import AboutRema from "../../components/REMA/AboutRema";
import FeaturedSpeakers from "../../components/REMA/FeaturedSpeakers";
import RemaFocus from "../../components/REMA/RemaFocus";
import WhatToExpect from "../../components/REMA/WhatToExpect";
import WhoShouldAttend from "../../components/REMA/WhoShouldAttend";
import ExhibitorsAndPartners from "../../components/REMA/ExhibitorsAndPartners";
import EventSchedule from "../../components/REMA/EventSchedule";
import CTA from "../../components/REMA/CTA";
import Footer from "../../components/REMA/Footer";
import MobileFooter from "../../components/REMA/MobileFooter";
import { Helmet } from "react-helmet";
import { ScrollTrigger } from "gsap/all";
import gsap from "gsap";

gsap.registerPlugin(ScrollTrigger);

const Rema = () => {
  return (
    <body className="overflow-x-hidden">
      <Helmet>
        <title>REMA 2025 - Real Estate Management in Africa | Venco</title>
        <meta
          property="og:title"
          content="REMA 2025 - Real Estate Management in Africa | Venco"
        />
        <meta
          name="twitter:title"
          content="REMA 2025 - Real Estate Management in Africa | Venco"
        />
      </Helmet>
      <Hero />
      <RemaConferenceTicker />
      <AboutRema />
      <FeaturedSpeakers />
      <WhatToExpect />
      <EventSchedule />
      <WhoShouldAttend />
      <RemaFocus />
      <ExhibitorsAndPartners />
      <CTA />
      <Footer />
      <MobileFooter />
    </body>
  );
};

export default Rema;
